import React, { useCallback } from 'react';
import { organisationsAPI } from '../../../../organisations/api/organisationsAPI';
import { useActivitySection } from '../../../hooks/useActivitySection';
import SectionState from './SectionState';
import { speakerLabel } from './lib/activityFormat';

const noTurns = (data) => !data.turns.length;

/**
 * One interview's transcript, from GET …/activity/interviews/<run_id>/transcript,
 * fetched when it is opened. Every line is shown as plain text, line breaks kept.
 */
const TranscriptView = ({ studentId, runId, id }) => {
  const fetchTranscript = useCallback((sid) => organisationsAPI.getStudentInterviewTranscript(sid, runId), [runId]);
  const state = useActivitySection(fetchTranscript, studentId, runId, { isEmpty: noTurns });
  return (
    <div id={id} className="td-act-transcript">
      <SectionState state={state} what="the transcript" emptyTitle="No turns were recorded for this interview" />
      {state.status === 'ready' ? (
        <ol className="td-act-turns">
          {state.data.turns.map((t) => (
            <li key={t.number} className={`td-act-turn td-act-turn--${t.speaker === 'candidate' ? 'candidate' : 'interviewer'}`}>
              <span className="td-act-turn__speaker">{speakerLabel(t.speaker) || 'Speaker'}</span>
              <p className="td-act-turn__text">{t.text}</p>
            </li>
          ))}
        </ol>
      ) : null}
    </div>
  );
};

export default TranscriptView;
